module.exports = __webpack_public_path__ + "img/xieyidingjia.12c1d99.png";